import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  email
} from "admin-on-rest";
import {
  validateAdminDataCreate,
  validatePassword,
  validatePhone
} from "./validations";
import {formStyle} from "./style";

class AdminsCreateForm extends React.Component {
  render() {
    const props = {...this.props};
    return (
      <Create title="resources.admins.titleCreate" {...props}>
        <SimpleForm
          redirect="list"
          validate={validateAdminDataCreate}
        >
          <TextInput
            label="resources.admins.inputs.email"
            source="email"
            type="email"
            validate={email}
          />

          <TextInput
            label="resources.admins.inputs.password"
            source="password"
            type="password"
            validate={validatePassword}
            style={formStyle.containerInput}
          />

          <TextInput
            label="resources.admins.inputs.repeatPassword"
            source="password2"
            type="password"
            validate={validatePassword}
          />

          <div style={formStyle.clearFloatContainer} />

          <TextInput
            label="resources.admins.inputs.phoneNumber"
            source="phone"
            validate={validatePhone}
          />
          
        </SimpleForm>
      </Create>
    );
  }
}

export default AdminsCreateForm;



// WEBPACK FOOTER //
// ./src/containers/CRM/Admins/AdminsCreateForm.js